import { Fragment } from "react";

// The pill rail. Pills are text only — never a number in a pill name; counts go in the toolbar's far-right text.
export function PillRail({ children, className = "", testId }) {
  return (
    <div className={`seg-rail inline-flex max-w-full flex-wrap items-center gap-1 rounded-2xl p-1 ${className}`} data-testid={testId}>
      {children}
    </div>
  );
}

export function Pill({ on, onClick, children, testId, title, onStyle, className = "" }) {
  return (
    <button type="button" onClick={onClick} title={title} data-testid={testId} aria-pressed={!!on}
      style={on && onStyle ? onStyle : undefined}
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-3 py-1 text-xs font-medium transition-colors ${on ? "seg-on" : "seg-off"} ${className}`}>
      {children}
    </button>
  );
}

// Thin vertical divider — the one view outside the live list (Archived, Won · Lost, Paid / Void) sits after it.
export function PillDivider() {
  return <span className="seg-divider mx-0.5 h-4 w-px" aria-hidden="true" />;
}

// Options: [{ key, label, dividerBefore, testId, title }]. Pressing the already-chosen outside view (dividerBefore)
// calls onChange(defaultKey) so it toggles back to the default list.
export default function Segmented({ options, value, onChange, defaultKey, className = "", leading = null, children, testId }) {
  return (
    <PillRail className={className} testId={testId}>
      {leading}
      {options.map((o) => {
        const on = value === o.key;
        return (
          <Fragment key={o.key}>
            {o.dividerBefore && <PillDivider />}
            <Pill on={on} title={o.title} testId={o.testId}
              onClick={() => onChange(on && o.dividerBefore && defaultKey !== undefined ? defaultKey : o.key)}>
              {o.label}
            </Pill>
          </Fragment>
        );
      })}
      {children}
    </PillRail>
  );
}
